// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1nDHs","noInteraction":"EventWrapper_noInteraction__1LLX5"};